import styled from 'styled-components';
import { Typography as MuiTypography } from '@mui/material';
import { colors } from '../../../config/colors';
export var StyledTypography = styled(MuiTypography).withConfig({
  displayName: "style__StyledTypography",
  componentId: "sc-1stguxb-0"
})(["", " &&{font-weight:", ";display:", ";color:", "}", " ", " ", " ", ""], function (_ref) {
  var maxlines = _ref.maxlines;
  return maxlines && "\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -moz-box-orient: vertical;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ".concat(maxlines, ";\n    \n    ");
}, function (_ref2) {
  var weight = _ref2.weight;
  return weight;
}, function (_ref3) {
  var display = _ref3.display;
  return display;
}, function (_ref4) {
  var color = _ref4.color;
  return color;
}, function (_ref5) {
  var breakWord = _ref5.breakWord;
  return breakWord && "word-break: break-word;";
}, function (_ref6) {
  var onClick = _ref6.onClick;
  return onClick && "cursor: pointer; ";
}, function (_ref7) {
  var margin = _ref7.margin;
  return margin && "margin: ".concat(margin, " !important;");
}, function (_ref8) {
  var color = _ref8.color;
  return color && "color: ".concat(color, ";");
});
export var StyledLink = styled.a.withConfig({
  displayName: "style__StyledLink",
  componentId: "sc-1stguxb-1"
})(["color:", ";& :hover{color:", ";}"], colors.secondaryColor[900], colors.secondaryColor[700]);